import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import ConditionsGenerales from '../pages/conditions-generales/page';
import Confidentialite from '../pages/confidentialite/page';
import Informations from '../pages/informations/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/a-propos',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/conditions-generales',
    element: <ConditionsGenerales />,
  },
  {
    path: '/confidentialite',
    element: <Confidentialite />,
  },
  {
    path: '/informations',
    element: <Informations />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
